import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = cookies.get("jwt-auth");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// تابع کمکی برای مدیریت خطاها
const handleError = (error) => {
  if (!error.response) {
    return {
      status: "network_error",
      message: "لطفا اتصال اینترنت خود را بررسی کنید",
    };
  }
  return error.response;
};

export const deleteArticle = async (deleteId) => {
  try {
    const response = await api.delete(`/article/${deleteId}`);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const getAllArticles = async () => {
  try {
    const response = await api.get("/article/all");
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const createArticle = async (data) => {
  try {
    const response = await api.post("/article/create", data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const updateArticle = async (data) => {
  try {
    const response = await api.post(`/article/edit`, data);
    return response;
  } catch (error) {
    return handleError(error);
  }
};

export const uploadArticleImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    const token = cookies.get("jwt-auth");
    const response = await axios.post(
      backendUrl + "/upload/articleImage",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    return err.response;
  }
};
